/**
 * Small numbers as words.
 *
 * `editor/Probe.tsx` wrote this rule first — "Small numbers read as words.
 * Beyond ten a figure is clearer than a phrase." — for "five points short of your
 * Hot threshold". Story 22.3 needed it again for "Four leads are waiting on you.",
 * so it moved here rather than being copied: a second copy of the map is the one
 * that stops agreeing.
 *
 * Story 22.3.
 */
const NUMBER_WORD = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten']

/** "four" for 4, "12" for 12. */
export const spell = (n: number): string => NUMBER_WORD[n] ?? String(n)

/** The first letter up, for a word that starts a sentence. */
export const capitalise = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1)
